import * as PropTypes from 'prop-types';

import {assert} from 'Asserts';
import DataTestAttrsType from 'test/lib/cypress/DataTestAttrsType';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {Optional} from 'util/Types';

export enum OptionContentType {
  ANCHOR = 'ANCHOR', // Indicate that the OptionContent should be wrapped in an <a>.
  INPUT = 'INPUT', // Indicate that the OptionContent will contain an <input>; ensures correct focus/padding
  PLAIN = 'PLAIN',
}

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export type OptionValue = any;

export interface OptionData {
  className?: string;
  disabled?: boolean;

  // A message to add to the value when the option is disabled
  disabledMessage?: string;

  // Any additional context that one might want to attach to the option
  extra?: {unstarrable?: boolean; headerId?: string};
  isHeader?: boolean;
  icon?: BenchlingIconName;
  iconClassName?: string;
  name: string | JSX.Element;
  pureTextName?: string;
  value?: OptionValue;
  submenu?: Array<Array<Optional<OptionData>>> | null;
  skipIconOverride?: boolean;
  hidden?: boolean;
  dataTestAttrs?: DataTestAttrs;
  metadata?: string | null;
  tooltipTitle?: string | null;
}

export const LOADING_OPTION_DATA: OptionData = {
  name: 'Loading...',
  value: null,
  pureTextName: '',
  disabled: true,
};

export const ERROR_OPTION_DATA: OptionData = {
  name: 'Error',
  value: null,
  pureTextName: '',
  disabled: true,
};

export function getOptionDataPureTextName(optionData: OptionData): string {
  if (optionData.pureTextName != null) {
    return optionData.pureTextName;
  }
  assert(
    typeof optionData.name === 'string',
    'An OptionData must either have a `name` of type string or define `pureTextName`',
    {optionData}
  );
  return optionData.name;
}

export const VALUE_SHAPE = PropTypes.any;

const OPTION_DATA_FIELDS = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  disabledMessage: PropTypes.string,
  // Any additional context that one might want to attach to the option
  extra: PropTypes.object,
  isHeader: PropTypes.bool,
  icon: PropTypes.string,
  name: PropTypes.node.isRequired,
  value: VALUE_SHAPE,
  dataTestAttrs: DataTestAttrsType,
};

export const OPTION_DATA_SHAPE = PropTypes.shape({
  ...OPTION_DATA_FIELDS,
  submenu: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape(OPTION_DATA_FIELDS))),
});

export enum MenuHeight {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  XLARGE = 'xl',
}

export enum MenuWidth {
  MINI = 'mini',
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  XLARGE = 'xl',
  XXLARGE = 'xxl',
  FULL = 'full',
  FIT_CONTENT = 'fitContent',
}
